import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExpandablePanelbarComponent } from './expandable-panelbar.component';
import { PanelBarModule } from '@progress/kendo-angular-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule } from '@progress/kendo-angular-grid';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { FormDialogModule } from '../form-dialog/form-dialog.module';
import { PanelbarService } from './expandable-panelbar.service';
import { UploadModule } from '@progress/kendo-angular-upload';
import { DataGridModule } from '../data-grid/data-grid.module';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';


@NgModule({
  imports: [
    CommonModule,
    PanelBarModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    MatListModule,
    MatIconModule,
    MatCardModule,
    TabStripModule,
    MatButtonModule,
    ButtonModule,
    UploadModule,
    FormDialogModule,
    DataGridModule,
    MatTooltipModule,
  ],
  declarations: [
    ExpandablePanelbarComponent
  ],
  exports: [
    ExpandablePanelbarComponent,
  ],
  providers: [
    PanelbarService
  ]

})
export class ExpandablePanelbarModule { }
